import Table from "../../components/Table";
import Layout from "../../components/Layout";
import { useAnalytics } from "../../features/analytics/analyticsProvider";
import { MaskedText } from "../../components/Table/MaskedText";

export default function AccountApiKey() {
  const { analytics } = useAnalytics();

  return (
    <Layout metaTitle="Account API Keys">
      <Table
        url="/d/apikeys/account_apikey/"
        formURL="/d/apikeys/account_apikey/form/"
        tableName="Account API Key"
        tableDescription="Account keys are mainly to authenticate account-level requests such as Transactions, Intents, or other account-owned entities."
        onAddItemSuccessfully={() => {
          analytics.track("user_api_key_created", {
            key_type: "account",
          });
        }}
        customPreview={{
          Content: {
            key: ({ key }) => (
              <MaskedText
                textKey="key"
                textValue={key}
                onRevealClick={() => {
                  window.Appcues?.track("api_key.viewed");
                }}
                onCopyClick={() => {
                  window.Appcues?.track("api_key.viewed");
                }}
              />
            ),
            public_key: ({ public_key }) => (
              <MaskedText
                textKey="public_key"
                textValue={public_key}
                onRevealClick={() => {
                  window.Appcues?.track("api_key.viewed");
                }}
                onCopyClick={() => {
                  window.Appcues?.track("api_key.viewed");
                }}
              />
            ),
          },
        }}
      />
    </Layout>
  );
}

AccountApiKey.parentPath = "/account-api-key";
